/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportDeleteUploadMutationResponse, SocialExportDeleteUploadPathParams, SocialExportDeleteUpload400, SocialExportDeleteUpload401, SocialExportDeleteUpload403, SocialExportDeleteUpload404 } from "../models/SocialExportDeleteUpload";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { socialExportDeleteUpload } from "../axios/socialExportDeleteUpload";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const socialExportDeleteUploadMutationKey = () => [{ url: '/social-export/v1/upload/:id' }] as const

export type SocialExportDeleteUploadMutationKey = ReturnType<typeof socialExportDeleteUploadMutationKey>

export function socialExportDeleteUploadMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = socialExportDeleteUploadMutationKey()
        return mutationOptions<SocialExportDeleteUploadMutationResponse, ResponseErrorConfig<SocialExportDeleteUpload400 | SocialExportDeleteUpload401 | SocialExportDeleteUpload403 | SocialExportDeleteUpload404>, {id: SocialExportDeleteUploadPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return socialExportDeleteUpload(id, config)
          },
        })

}

/**
 * @description Removes the published media from the platform (when applicable) and deletes the upload record.
 * @summary Delete an upload from the platform
 * {@link /social-export/v1/upload/:id}
 */
export function useSocialExportDeleteUpload<TContext>(options: 
{
  mutation?: UseMutationOptions<SocialExportDeleteUploadMutationResponse, ResponseErrorConfig<SocialExportDeleteUpload400 | SocialExportDeleteUpload401 | SocialExportDeleteUpload403 | SocialExportDeleteUpload404>, {id: SocialExportDeleteUploadPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? socialExportDeleteUploadMutationKey()

          const baseOptions = socialExportDeleteUploadMutationOptions(config) as UseMutationOptions<SocialExportDeleteUploadMutationResponse, ResponseErrorConfig<SocialExportDeleteUpload400 | SocialExportDeleteUpload401 | SocialExportDeleteUpload403 | SocialExportDeleteUpload404>, {id: SocialExportDeleteUploadPathParams["id"]}, TContext>
          

          return useMutation<SocialExportDeleteUploadMutationResponse, ResponseErrorConfig<SocialExportDeleteUpload400 | SocialExportDeleteUpload401 | SocialExportDeleteUpload403 | SocialExportDeleteUpload404>, {id: SocialExportDeleteUploadPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SocialExportDeleteUploadMutationResponse, ResponseErrorConfig<SocialExportDeleteUpload400 | SocialExportDeleteUpload401 | SocialExportDeleteUpload403 | SocialExportDeleteUpload404>, {id: SocialExportDeleteUploadPathParams["id"]}, TContext>
      
}